var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#002400;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1977",
    "data-name": "Group 1977"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    className: "cls-1",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-youtube-3451621",
    className: "cls-2",
    d: "M23.35,10.48a36.13,36.13,0,0,0-11.74,0C9.39,11,8,12.38,8,14.26v6.65c0,1.9,1.39,3.31,3.65,3.8h0a35.46,35.46,0,0,0,11.72,0c2.2-.41,3.63-1.9,3.63-3.8V14.27c0-1.89-1.43-3.37-3.65-3.78ZM20.6,18l-4.75,2.85a.54.54,0,0,1-.25.06.69.69,0,0,1-.24-.05.49.49,0,0,1-.23-.44v-5.7a.5.5,0,0,1,.23-.42.53.53,0,0,1,.49,0l4.75,2.85a.49.49,0,0,1,.14.67.4.4,0,0,1-.14.15Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.df2702b2ef2e3237d3894a9e3e637384.svg";
export { ForwardRef as ReactComponent };